import { createSelector } from 'reselect'

import { getApiPublicContacts, getPublicContactsLookup } from '../api/selectors'

export const makeGetPublicContact = () =>
  createSelector(
    [getApiPublicContacts, getPublicContactsLookup, (_, props) => props.handle],
    (publicContacts, publicContactsLookup, handle) => {
      const id = publicContactsLookup?.[handle]
      return id && publicContacts?.[id]
    },
  )
